export default __webpack_public_path__ + "static/part3_6-9e464fdfd2eae2c466a5d28e43c7206a.png";